import type { FaireProductEntity } from "../../entity_types/product";

export const p_g93p6uh4zf: FaireProductEntity = {
  token: "p_g93p6uh4zf",
  type: "product",
  name: "bouquets watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/2c956495376243fb97b0f1bc9610039ce7c3534ba8e66e843f6031e3eff1e306.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/485d2ab85d1b0c1d120398e50e8eb47dab4d446db8fe4d0c25e80ec44537d51e.jpeg",
    "https://cdn.faire.com/fastly/fcb21b02b486b36a1a8f45964433d4bbe6ab79781d9b60acdb683bc1d3d807c2.jpeg",
    "https://cdn.faire.com/fastly/4b932506d03eac7d33f7a0907683f139c65edaee00721b1aeee96bb13f33c11b.jpeg",
    "https://cdn.faire.com/fastly/1cc8f909d4a53582bb2ffd14c1671a70ae83131333b0a00386243ec20f26ef33.jpeg",
    "https://cdn.faire.com/fastly/34452f6bd7040d6c11b7eff3fded24e58ddfbfeb384aa83caf7c4cfa2ebd97b7.jpeg",
    "https://cdn.faire.com/fastly/ff484b5e2ebe1c9639e6b4a06d8b539271a582c1545a30918cfa061ef42bdbbf.jpeg",
    "https://cdn.faire.com/fastly/12c669d55493f543bb831ce0498d84dd084ce17c1223fb27191c60e829bd4f17.jpeg",
  ],
  priceDollars: 12,
  description:
    "A favorite for flower lovers. Twelve lovely arrangements — peonies in a striped pitcher, sunflowers, tulips, garden mixes, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA reliable companion to the Flowers workbook. Carry both for customers who return for a second title, and pair with the paint set for a finished gift.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:09.360Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
